package ld.scenes;

import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.extras.BitmapText;
import pixi.extras.AnimatedSprite;

import stocking.ColoredBitmapText;
import stocking.SceneManager;

import tweenx909.TweenX;
import tweenxcore.color.RgbColor;
import tweenxcore.Tools.Easing;

import ld.NotificationWindow;

import stocking.AudioManager;



import stocking.Scene;

class VictoryScene extends Scene
{
	var bgPosition = { x: 0., y: 0.};
	var containerScene : Container = new Container();
	var containerBG : Container = new Container();

	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );
	}

    public override function preload()
    {
		loaderImages = [
			{ filename: "assets/bunny.png"},
			
		];

		loaderFonts = [
			"assets/khdot16.fnt",
			"assets/khdot12.fnt",
		];

		loaderSfx = [
			//"assets/hover.ogg",
			
		];
		super.preload();
    }

	public override function enter()
	{
		super.enter();

		trace("Enter");

		container.addChild(containerBG);
		container.addChild(containerScene);
		
		
	
		// New game btn
		var btn = MakeButton("Victory");
		btn.click = btn.tap = function( event : pixi.interaction.InteractionEvent ) { 
			
			TweenX.to( container, {alpha: 0}).time(0.5).onFinish(function(){
				
				exited = true;
				this.stage.removeChild( this.container );
				SceneManager.instance.transitionToScene(new MapScene(renderer, stage));
			});
		};

		var btnStart =  10;
		var btnSpace = 103;
		var btnY = 185;

		
	
		btn.x = 320;
		btn.y = btnY;
		TweenX.to( btn, { x: btnStart } ).delay(0.5).time(0.2);

		containerScene.addChild( btn );



		btn.x = 320;
		btn.y = btnY;
		TweenX.to( btn, { x: btnStart + btnSpace } ).delay(0.5 + 0.1).time(0.2);


		containerScene.addChild( btn );


		container.alpha = 0;

		TweenX.to( container, { alpha: 1 } ).time(1);
		
		
	}

	public override function tick( delta : Float )
	{
		
	}

	public function MakeButton( text : String )
	{
		var choiceContainer = new Container();
		//var button = new Sprite( Texture.fromImage( "assets/choice_container.png" ) );
		//choiceContainer.addChild(button);

		var shadowText = new BitmapText( text, { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
		shadowText.position.y = 8;
		shadowText.anchor.x = 0.5;
		shadowText.position.x = 95/2 + 1;
		shadowText.tint = 0x0;
		//optionText
		shadowText.align = BitmapTextAlign.CENTER;
		choiceContainer.addChild(shadowText);
		
		var optionText = new BitmapText( text, { font: "16px khdot16", align: BitmapTextAlign.CENTER } );
		optionText.position.y = 7;
		optionText.anchor.x = 0.5;
		optionText.position.x = 95/2;
		optionText.tint = 0xaaaaaa;
		//optionText
		optionText.align = BitmapTextAlign.CENTER;
		choiceContainer.addChild(optionText);

		choiceContainer.mouseover = function( event : pixi.interaction.InteractionEvent ) { 
			AudioManager.instance.play("hover");
			TweenX.to( optionText, {tint: RgbColor.of( 0xffffff ) } ).time(0.2);
		};
		choiceContainer.mouseout = function( event : pixi.interaction.InteractionEvent ) { 
			TweenX.to( optionText, {tint: RgbColor.of( 0xaaaaaa ) } ).time(0.2);
		};

		choiceContainer.interactive = true;

		return choiceContainer;
	}

	public override function exit()
	{
		//this.stage.removeChild( this.container );
		//exited = true;
	}
}
